import { TextField, NumberInput, TextInput } from "react-admin";

import BusinessIcon from "@mui/icons-material/Business";
import { JsonField } from "../ra-lb-tools/components/jsonField";
import { MyList } from "../ra-lb-tools/components/myList";
import { MyReferenceField } from "../ra-lb-tools/components/myReference";
import { UserField, UserInput } from "./users";
import { LockerUsageEventList } from "./billing/lockerUsageEvent";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import { useParams } from "react-router-dom";
import { OpenLockerTokenList } from "./openLockerTokens";
import { ClientField } from "./clients";
import { MyDateField } from "../ra-lb-tools/components/myDateField";
import { MyBooleanField } from "../components/myBooleanField";

export const SystemIcon = BusinessIcon;

export const LockerOpenRequestList = (props) => {
  const filters = [
    <NumberInput source="lockerId" alwaysOn key={1} label="Locker Id" />,
    <TextInput source="status" alwaysOn key={3} />,
    <UserInput source="userId" alwaysOn key={4} label="User" />,
    <TextInput source="clientInfo" alwaysOn key={5} />,
  ];

  const title = "Locker Open Request";
  const resource = "locker-open-requests";

  return (
    <MyList
      title={title}
      resource={resource}
      sort={{
        field: "id",
        order: "DESC",
      }}
      filters={filters}
      {...props}
    >
      <TextField source="id" />
      <MyReferenceField source="lockerId" reference="lockers" />
      <ClientField source="clientExternalId" label="Client" sortable={false} />
      <TextField source="returnUrl" />
      <TextField source="linkToken" />
      <TextField source="intent" />
      <TextField source="status" />
      <JsonField source="payload" />
      <MyDateField source="createdAt" showTime />
      <MyDateField source="updatedAt" showTime />
      <UserField source="userId" />
      <TextField source="clientInfo" />
      <TextField source="keypadIntent" />
      <TextField source="nextKeypadCode" />
      <MyBooleanField source="persistKeypadCode" />
    </MyList>
  );
};

export const LockerOpenRequestShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow>
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <MyReferenceField source="lockerId" reference="lockers" />
              <ClientField
                source="clientExternalId"
                label="Client"
                sortable={false}
              />
              <TextField source="returnUrl" />
              <TextField source="linkToken" />
              <TextField source="intent" />
            </LabeledColumn>
            <LabeledColumn>
              <TextField source="status" />
              <MyDateField source="createdAt" showTime />
              <MyDateField source="updatedAt" showTime />
              <UserField source="userId" />
              <JsonField source="payload" />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
        <Tab
          label="Locker Usage Events"
          path="locker-usage-events"
          can={{ action: "list", resource: "locker-usage-events" }}
        >
          <LockerUsageEventList filter={{ lockerOpenRequestId: id }} />
        </Tab>
        <Tab
          label="Open Locker Tokens"
          path="open-locker-tokens"
          can={{ action: "list", resource: "open-locker-tokens" }}
        >
          <OpenLockerTokenList filter={{ lockerOpenRequestId: id }} />
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};
